/**
 * Shared date formatter for the admin surfaces.
 * Produces a stable "Jul 16, 2026" (en-US, short month) format so trial
 * end dates, billing dates, etc. render identically across tabs.
 */
export function formatDate(dateStr: string | null | undefined): string {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}
